module.exports = "<div>\r\n\t<bws-banner design-type=\"Header\"></bws-banner>\r\n\t<div>\r\n\t\t<div item id=\"map-canvas\" class=\"map-canvas\"></div>\r\n\t</div>\r\n\r\n\t<bws-banner design-type=\"Footer\"></bws-banner>\r\n</div>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/shoplocator/storedetails/shop-details-template.html
 ** module id = 1017
 ** module chunks = 1
 **/